<!-- temporally -->
<template>
    <b-modal
        v-model="isModalOpen"
        size="lg"
        modal-class="vue-need-bootstrap"
        ok-only
        scrollable
        centered
        title="New file"
        no-close-on-backdrop
        no-close-on-esc
        @close="onClose"
    >
        <template #modal-title>
            <div class="warning-modal-title">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_70_33)">
                        <path
                            d="M12 1.5C12.6656 1.5 13.2797 1.85156 13.6172 2.42812L23.7422 19.6781C24.0844 20.2594 24.0844 20.9766 23.7515 21.5578C23.4187 22.1391 22.7953 22.5 22.125 22.5H1.87498C1.20467 22.5 0.581229 22.1391 0.248416 21.5578C-0.0843962 20.9766 -0.0797087 20.2547 0.257791 19.6781L10.3828 2.42812C10.7203 1.85156 11.3344 1.5 12 1.5ZM12 7.5C11.3765 7.5 10.875 8.00156 10.875 8.625V13.875C10.875 14.4984 11.3765 15 12 15C12.6234 15 13.125 14.4984 13.125 13.875V8.625C13.125 8.00156 12.6234 7.5 12 7.5ZM13.5 18C13.5 17.6022 13.3419 17.2206 13.0606 16.9393C12.7793 16.658 12.3978 16.5 12 16.5C11.6022 16.5 11.2206 16.658 10.9393 16.9393C10.658 17.2206 10.5 17.6022 10.5 18C10.5 18.3978 10.658 18.7794 10.9393 19.0607C11.2206 19.342 11.6022 19.5 12 19.5C12.3978 19.5 12.7793 19.342 13.0606 19.0607C13.3419 18.7794 13.5 18.3978 13.5 18Z"
                            fill="#FFC748"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_70_33">
                            <rect width="24" height="24" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
                New file
            </div>
        </template>
        <div class="warning-modal">
            <div class="warning-modal__warning">
                <p>
                    Templates with multiple files are only supported in <strong>Shopify</strong>,
                    <strong>Etsy</strong> and <strong>Woocommerce</strong> stores.
                </p>

                <c-checkbox v-model="isAccepted" class="accept">
                    <p>Don’t show me this message again.</p>
                </c-checkbox>
            </div>
        </div>

        <template #modal-footer>
            <div class="w-100">
                <button class="btn btn-primary" @click="onAccepted">Close</button>
            </div>
        </template>
    </b-modal>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { BModal } from 'bootstrap-vue';
import CCheckbox from '@/components/shared/CCheckbox.vue';

const emit = defineEmits<{
    (event: 'accepted', value: boolean): void;
    (event: 'close'): void;
}>();

const isModalOpen = ref(true);
const isAccepted = ref(false);

const onAccepted = () => {
    emit('accepted', isAccepted.value);
};

const onClose = () => {
    emit('close');
};
</script>

<style lang="scss" scoped>
.warning-modal-title {
    display: flex;
    align-items: center;
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
    gap: 10px;
    color: #333333;
}

.warning-modal {
    color: #333333;
    font-weight: 400;

    font-size: 14px;

    letter-spacing: 0em;
    text-align: left;

    .accept {
        display: flex !important;
        align-items: center !important;
    }

    &__warning {
        padding: 20px 16px 0 16px;
    }

    &__all-warning {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 10px;
        border-radius: 4px;
        background-color: #efeefc;
    }
}

.vue-need-bootstrap {
    .btn {
        padding: 0.25rem 1rem;

        &.btn-continue {
            background-color: var(--primary-purple) !important;
            font-weight: bold;
            color: white;
        }

        &.btn-cancel {
            border: 2px solid #7258e0;
            font-weight: bold;
            color: #7258e0;

            &:hover {
                background-color: #7258e0 !important;
                color: white;
            }
        }
    }
}
</style>
